import { IConstructionProgressImage } from '../../repositories/construction-progress/entities/get_construction_progress_page/ConstructionProgressImage';
import { formatDate, formatEmpty } from '../../utils/formatters';
import { getBuildingProgressText } from './getBuildingProgressText';
import { getHouseTitle } from './getHouseTitle';

export const prepareImageText = (image: IConstructionProgressImage, newbuildingName: string, date: string): string => {
  const buildingProgressText = getBuildingProgressText();
  const housesNames = getHouseTitle(image.housesNames);

  return `ЖК "${newbuildingName}"${formatEmpty(housesNames)}, ${buildingProgressText} от ${formatDate(date)}`;
};
